module.exports = __webpack_public_path__ + "img/gui_churujing.3798b493.png";